<template>
  <div class="variables-inspection-container">
    <div class="variables-inspection-section">
      <div class="variables-inspection-output" v-html="parsedMessage"></div>
    </div>

    <div class="variables-inspection-caption">
      <div v-for="caption in captions" :key="caption.type" class="caption-element">
        <div :class="`${caption.type}-style caption-element-block`"></div>
        <span class="caption-element-text">{{ caption.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { variablesInspection } from '@/modules/maria/campanha-da-maria-v2/mixins/variables-inspection'

export default {
  name: 'SmsPreview',
  mixins: [variablesInspection],
  data: () => ({
    captions: [
      { text: 'Caractere', type: 'char' },
      { text: 'Caractere especial', type: 'special-char' },
      { text: 'Espaço', type: 'space' },
      { text: 'Variável', type: 'variable' },
      { text: 'Subvariável', type: 'subvariable' },
    ],
  }),
}
</script>

<style lang="scss" scoped>
.variables-inspection-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  .variables-inspection-section {
    border: 1px solid $cinza-l60;
    background-color: #ffffff;
    height: 200px;
    overflow: auto;
    .variables-inspection-output {
      width: 100%;
      border-radius: 3px;
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.variables-inspection-caption {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  .caption-element {
    display: flex;
    flex-direction: row;
    gap: 6px;
    .caption-element-block {
      border-radius: 2px;
      width: 14px;
      height: 17px;
    }
    .caption-element-text {
      font-weight: 400;
      font-size: 14px;
      line-height: 16.8px;
      letter-spacing: 0.23px;
      color: #656565;
    }
  }
}

::v-deep .inspection-text {
  border: 1px solid #a9e34b;
  font-family: 'Roboto Mono', monospace;
  font-size: 12px;
  user-select: none;
  margin: 1px;
  padding-left: 2px;
  padding-right: 2px;
  letter-spacing: 2px;
  border-radius: 4px;
  max-height: 24px;
  min-width: 18px;
  display: inline-block;
  text-align: center;
  user-select: none;
  color: #6b7580;
}

::v-deep .best-offer-bg {
  background-color: #dbcffb;
  padding: 4px;
  border-radius: 6px;
  display: inline-block;
}

::v-deep .char-style {
  background-color: #ffffff;
  border: 1px solid #d4ff00;
}

::v-deep .special-char-style {
  background-color: #fcce9d;
  border: 1px solid #f47f68;
}

::v-deep .space-style {
  background-color: #e1f4bb;
  border: 1px solid #bfe600;
}

::v-deep .variable-style {
  background-color: #dbcffb;
  border: 1px solid #b09bf6;
}

::v-deep .subvariable-style {
  background-color: #f2c1e7;
  border: 1px solid #ec85d8;
}
</style>
